"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _underscore = _interopRequireDefault(require("underscore"));
var _program = require("@studio/program");
var _constants = require("@studio/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Check if layer is screen share or media.
 *
 * @param layer
 * @returns {boolean}
 */
var isScreenShareOrMedia = function isScreenShareOrMedia(layer) {
  var _layer$source;
  return [_constants.SCREEN_PRESENTER, _constants.MEDIA, _constants.VIDEO_FILE, _constants.IMAGE_FILE].includes(layer === null || layer === void 0 || (_layer$source = layer.source) === null || _layer$source === void 0 ? void 0 : _layer$source.type);
};

/**
 * Check if the scene layout is featured.
 *
 * @param scene
 * @returns {boolean}
 */
var isFeaturedLayout = function isFeaturedLayout(scene) {
  return [_constants.FEATURED_MEDIA.id, _constants.FEATURED_SCREEN.id, _constants.FEATURED_PRESENTER.id].includes(scene === null || scene === void 0 ? void 0 : scene.layout);
};

/**
 *
 * @param scenes
 * @param sourceId
 * @param isBackgroundSource
 * @param fonts
 * @returns {*}
 */
var removeSourceFromScene = function removeSourceFromScene(scenes, sourceId, isBackgroundSource) {
  var fonts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return scenes.map(function (scene) {
    // not a background source
    if (!isBackgroundSource) {
      scene.layers = scene.layers.filter(function (layer) {
        // layer._id within the condition handles the case where source
        // is an overlay or a banner then the layer._id is the id of the overlay or banner
        var filterCondition = layer.source._id !== sourceId && layer._id !== sourceId && layer.source.value !== sourceId; // audioPresenter can have its value equal to the source Id

        if (layer.source.type === _constants.BANNER) {
          var _layer$source$_id$spl = layer.source._id.split('_'),
            _layer$source$_id$spl2 = _slicedToArray(_layer$source$_id$spl, 1),
            bannerId = _layer$source$_id$spl2[0];
          filterCondition = filterCondition && layer.source._id !== "".concat(bannerId, "_").concat(sourceId);
        }
        return filterCondition;
      });
      var canSwitchToSingleView, canSwitchToGridView;

      // An assignedLayer is a layer that is assigned and isn't an overlay
      var assignedLayers = scene.layers.filter(function (layer) {
        var _layer$layer;
        return !layer._id.includes(_constants.UNASSIGNED) && !(0, _program.isOverlay)(layer === null || layer === void 0 || (_layer$layer = layer.layer) === null || _layer$layer === void 0 ? void 0 : _layer$layer.style) && !(layer.source.type === _constants.AUDIO_PRESENTER && layer.source._id.includes('#content'));
      });

      // If there's no assignedLayer after deleting, reset the scene.layout to SINGLE view
      // so that it isn't stuck in the previous GRID/FEATURED layout
      if (!assignedLayers.length) {
        canSwitchToSingleView = true;
      } else if (isFeaturedLayout(scene)) {
        if (assignedLayers.length === 1) {
          var assignedLayer = assignedLayers[0];

          // if the only source left is a screen share or media
          canSwitchToSingleView = isScreenShareOrMedia(assignedLayer);

          // if the only source left is any other source type except screen share or media
          if (!canSwitchToSingleView) {
            canSwitchToGridView = true;
          }
        } else {
          // if all the sources left are not screen share or media
          canSwitchToGridView = assignedLayers.every(function (layer) {
            return !isScreenShareOrMedia(layer);
          });
        }
      }
      if (canSwitchToSingleView) {
        scene.layout = _constants.SINGLE.id;
      } else {
        scene.layout = canSwitchToGridView ? _constants.GRID.id : scene.layout;
      }
      return (0, _program.prepareSceneForUpdate)(_underscore["default"].clone(scene), fonts);
    }

    // we're removing a background source
    scene.style = {
      backgroundColor: '#000000'
    };
    return scene;
  });
};
var _default = exports["default"] = removeSourceFromScene;